// skipcq: JS-W1028
import React, { useMemo } from 'react';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import LoginWelcomePane from './LoginWelcomePane';
import LoginClaimPane from './LoginClaimPane';

export default function LoginColumns({ onSignupSuccessNavigate }) {
  const rowDivider = useMemo(
    () => (
      <Divider
        orientation="vertical"
        flexItem
        sx={{ display: { xs: 'none', md: 'block' } }}
      />
    ),
    [],
  );

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      divider={rowDivider}
      sx={{
        flex: 1,
        minHeight: 0,
      }}
    >
      <LoginWelcomePane />
      <Divider sx={{ display: { xs: 'block', md: 'none' } }} />
      <LoginClaimPane onSignupSuccessNavigate={onSignupSuccessNavigate} />
    </Stack>
  );
}
